/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Grid, Typography } from '@material-ui/core';

import DcmIcon from '../../assets/images/dcm.svg';
import TableFooter from '../common/TableFooter';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles(() => {
  return {
    imageContainer: {
      backgroundColor: '#172B4D',
      borderRadius: '4px',
      left: '8px',
      padding: '8px 4px',
      position: 'absolute',
      top: '8px',
    },
    imageFile: {
      width: '28px',
    },
    thumbnailContainer: {
      backgroundColor: '#F5F5F5',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      cursor: 'pointer',
      paddingBottom: '80%',
      position: 'relative',
      width: '100%',
    },
    typographyContainer: {
      marginTop: '8px',
      padding: '0px 8px',
    },
    typographyNoThumbnail: {
      color: '#999999',
      fontSize: '16px',
      fontWeight: 'bold',
      left: '50%',
      position: 'absolute',
      textAlign: 'center',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
    typographyNotAvailable: {
      color: '#999999',
      fontSize: '16px',
      lineHeight: '20px',
      textAlign: 'center',
    },
    typographySize: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '14px',
      textAlign: 'left',
    },
    typographyTitle: {
      color: '#172B4D',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '20px',
      textAlign: 'left',
      wordBreak: 'break-word',
      wordWrap: 'break-word',
    },
  };
});

export default ({ studies, total, onOpenViewer, criteria, onPageUpdate }) => {
  const classes = useStyles();
  const handleOpenViewer = (data) => {
    if (onOpenViewer) onOpenViewer(data);
  };

  const handlePageUpdate = (page) => {
    if (onPageUpdate) onPageUpdate(page);
  };

  const renderStudies = () => {
    return studies.map((study) => {
      const thumbnailPath = study?.resource?.customThumbnailPath || study?.resource?.thumbnailPath;
      if (!thumbnailPath) {
        return (
          <Grid key={`${study.id}_${study.resource.id}`} item xs={12} sm={6} md={4} lg={2}>
            <div onClick={() => handleOpenViewer(study)} className={classes.thumbnailContainer} style={{ position: 'relative' }}>
              <div className={classes.imageContainer}>
                <img className={classes.imageFile} src={DcmIcon} alt="dcm-icon" />
              </div>
              <Typography className={classes.typographyNoThumbnail}>COMPARISON STUDY</Typography>
            </div>

            <div className={classes.typographyContainer}>
              <SimpleTooltip title={study?.description || ''} disabled={!study?.description} placement="bottom">
                <Typography onClick={() => handleOpenViewer(study)} className={classes.typographyTitle}>
                  {study.title}
                </Typography>
              </SimpleTooltip>
            </div>
          </Grid>
        );
      }

      return (
        <Grid key={`${study.id}_${study.resource.id}`} item xs={12} sm={6} md={4} lg={2}>
          <div onClick={() => handleOpenViewer(study)} className={classes.thumbnailContainer} style={{ backgroundImage: `url(${thumbnailPath})`, position: 'relative' }}>
            <div className={classes.imageContainer}>
              <img className={classes.imageFile} src={DcmIcon} alt="dcm-icon" />
            </div>
          </div>

          <div className={classes.typographyContainer}>
            <SimpleTooltip title={study?.description || ''} disabled={!study?.description} placement="bottom">
              <Typography onClick={() => handleOpenViewer(study)} className={classes.typographyTitle}>
                {study.title}
              </Typography>
            </SimpleTooltip>
          </div>
        </Grid>
      );
    });
  };

  if (!studies.length) {
    return <Typography className={classes.typographyNotAvailable}>No results found</Typography>;
  }

  return (
    <div>
      <Grid container spacing={3}>
        {renderStudies()}
      </Grid>
      {!!studies.length && (
        <div>
          <TableFooter count={total} page={criteria.page} rowsPerPage={criteria.limit} changePage={(page) => handlePageUpdate(page)} />
        </div>
      )}
    </div>
  );
};
